module.exports = __webpack_public_path__ + "static/img/btn1@2x.1507200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/btn1@2x.png
// module id = jFfz
// module chunks = 70